// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"116":"23e4fcd6","135":"4ecac64c","276":"77cde8f3","358":"f5d0afc3","386":"e3e81c84","426":"5bb0e262","527":"41ebcc8e","549":"fcbe1ed4","555":"08cd4f5d","622":"a945acab","629":"9c3fd238","774":"4a26ef77","822":"76c6e036","825":"f540a68b"}[chunkId] + ".chunk.js";
};